import { authHeader, handleResponse } from '../helpers'

export const fileService = {
    deleteFile
};

function deleteFile(fileId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + '/file/' + fileId, requestOptions)
    .then(handleResponse)
    .then(response => {
        var file = response;
        return file;
    });
}